import MaterialTabs from "@mui/material/Tabs";
import { FC, ReactNode, Suspense } from "react";
import { styled } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageLoader } from "./PageLoader";
import { COLORS } from "../../constants/colors";
// TODO: refactor this component: move Tab items to children - as far as we are using "Outlet"
// from react-router, we haven't put related views into children collection
interface TabsProps {
  value?: string;
  children: ReactNode;
  context?: unknown;
}

const StyledTabs = styled(MaterialTabs)`
  .MuiTab-root {
    min-height: 2em;
    color: ${COLORS.TEXT_SECONDARY};
    text-transform: none;
    padding-left: 0;
    padding-right: 0;
    margin-right: 30px;
    min-width: 0;
    font-weight: 400;
  }
  .MuiTabs-root {
    min-height: 3rem;
  }

  .MuiTab-root.Mui-selected {
    color: ${COLORS.TEXT_PRIMARY};
    font-weight: 900;
  }

  .MuiTabs-scroller {
    position: relative;
  }

  .MuiTabs-scroller:after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${COLORS.BORDER_SUBTLE};
    z-index: 1;
  }

  .MuiTabs-indicator {
    z-index: 2;
  }

  .MuiTabs-indicator {
    background-color: ${COLORS.PRIMARY};
    bottom: auto;
  }
`;

export const Tabs: FC<TabsProps> = ({ value, children, context }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <StyledTabs
        value={value !== undefined ? value : location.pathname}
        onChange={(_event, nextValue: string) => navigate(nextValue)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
      >
        {children}
      </StyledTabs>
      <Suspense fallback={<PageLoader size="large" />}>
        <Outlet context={context} />
      </Suspense>
    </>
  );
};
